import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ allowedRoles }) => {
    const token = localStorage.getItem('access_token');
    const userStr = localStorage.getItem('user_info');
    
    // 1. Chưa đăng nhập (GUEST) -> Bắt về trang Login
    if (!token || !userStr) {
        return <Navigate to="/login" replace />;
    }

    const user = JSON.parse(userStr);

    // 2. Nếu Route có yêu cầu Role cụ thể (VD: Cần ADMIN hoặc MANAGER)
    if (allowedRoles && allowedRoles.length > 0) {
        // Nếu role của user không nằm trong danh sách cho phép -> Đá về trang chủ
        if (!allowedRoles.includes(user.role)) {
            toast("Bạn không có quyền truy cập trang này!");
            return <Navigate to="/" replace />;
        }
    }

    // 3. Hợp lệ -> Cho phép render component con
    return <Outlet />;
};

export default ProtectedRoute;